import { useQuery } from '@tanstack/vue-query';
import { ref } from 'vue';
import { getNetworkProfile } from '@infuse/api/e-connector/network-profile';
import { mapToDomain, NetworkProfile } from '@infuse/e-connector/network-profile/domain';

export const useNetworkProfile = () => {
  const fetchNetworkProfileId = ref<string | undefined>(undefined);

  const query = useQuery<NetworkProfile>({
    queryKey: ['network-profiles', 'detail', fetchNetworkProfileId],
    enabled: () => !!fetchNetworkProfileId.value,
    queryFn: async () => {
      const response = await getNetworkProfile({ id: fetchNetworkProfileId.value });
      return mapToDomain(response);
    }
  });

  return {
    ...query,
    fetchNetworkProfileId,
    networkProfile: query.data
  };
};
